import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { formatCpfCnpj } from './cpf-cnpj.mask';

// Substitui o pipe homônimo do @mandae/ng-utils/mask. Aceita CPF (11 dígitos) e
// CNPJ alfanumérico (12 caracteres [A-Z0-9] + 2 dígitos verificadores) conforme
// IN RFB nº 2.229/2024.
@Pipe({ name: 'cpfCnpjMask' })
export class CpfCnpjMaskPipe implements PipeTransform {
  transform(value: string): string {
    return formatCpfCnpj(value);
  }
}

@NgModule({
  declarations: [CpfCnpjMaskPipe],
  exports: [CpfCnpjMaskPipe],
})
export class CpfCnpjMaskPipeModule { }
